import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1001aa88&scoped=true"
import script from "./index?vue&type=script&lang=js&external"
export * from "./index?vue&type=script&lang=js&external"
import style0 from "./index.css?vue&type=style&index=0&id=1001aa88&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1001aa88",
  null
  
)

export default component.exports